module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



//////////////////
// WEBPACK FOOTER
// ./~/bl/~/readable-stream/lib/internal/streams/from-browser.js
// module id = 229
// module chunks = 73